<template>
  <div class="detail">
    <Tit-Box ref="title">
      <div class="obstruct"></div>
      <div class="logo1">
        <img src="@/assets/logo.png" />
      </div>
    </Tit-Box>
    <div class="nav">
      <div class="navinfo widthCommon">
        <p class="titp">
          Personalized Image Aesthetic Assessment with Rich Attributes
        </p>

        <HeaderName
          :nameList="nameList"
          :ceriNameList="ceriNameList"
        ></HeaderName>
      </div>
    </div>
    <div class="content widthCommon">
      <div class="material">
        <img src="~@/assets/素材图片1.png" />
      </div>

      <div class="english">
        &emsp;&emsp; Personalized image aesthetics assessment (PIAA) is
        challenging due to its highly subjective nature. People's aesthetic
        tastes depend on diversified factors, including image characteristics
        and subject characters. The existing PIAA databases are limited in terms
        of annotation diversity, especially the subject aspect, which can no
        longer meet the increasing demands of PIAA research. To solve the
        dilemma, we conduct so far, the most comprehensive subjective study of
        personalized image aesthetics and introduce a new Personalized image
        Aesthetics database with Rich Attributes (PARA), which consists of
        31,220 images with annotations by 438 subjects. PARA features wealthy
        annotations, including 9 image-oriented objective attributes and 4
        human-oriented subjective attributes. In addition, desensitized subject
        information, such as personality traits, is also provided to support
        study of PIAA and user portraits. A comprehensive analysis of the
        annotation data is provided and statistic study indicates that the
        aesthetic preferences can be mirrored by proposed subjective attributes.
        We also propose a conditional PIAA model by utilizing subject
        information as conditional prior. Experimental results indicate that the
        conditional PIAA model can outperform the control group, which is also
        the first attempt to demonstrate how image aesthetics and subject
        characters interact to produce the intricate personalized tastes on
        image aesthetics. We believe the database and the associated analysis
        would be useful for conducting next-generation PIAA study.
        <div style="display: block; height: 20px"></div>
        <div class="sitep">
          <div class="module_title">Bibliography：</div>
          <div class="module_text">
            If you find our work useful, please cite this paper, thank you!
            Arxiv Link:
            <a class="down_href" :href="BibliographyHref" target="block"
              >[PDF]</a
            >
          </div>
          <!-- Bibliography：<span style="color: #1364ef">www.xxxxxxxx.com</span> -->
        </div>
        <div class="sitep">
          <div class="module_title">Download Instruction：</div>
          <div>
            PARA database can be downloaded from here
            <a class="down_href" :href="downloadHref" target="block"
              >[Download PARA]</a
            >
          </div>
          <p></p>
          <div>
            Please note that in the annotation file of PARA, the
            "isObjectEmphasis" refers to whether there exists any salient object
            in this image. "0" means that "yes, there exist some salient
            objects" and "1" means "no, there does not exist any salient
            object". In the GiaaTrain.csv file, the "isObjectEmphasis_mean"
            equals to "isObjectEmphasis_1 / (isObjectEmphasis_1 +
            isObjectEmphasis_0)".
          </div>
        </div>
        <el-divider></el-divider>

        <!-- <div class="sitep">
          <div class="module_title">Recruitment Information：</div>
          <div class="module_text_flex">
            <div>
              OPPO Research Institute still has open positions (both full-time
              and intern) around computer vision. If any interests, please feel
              free to contact with Yaqian Li，
            </div>
            <div>
              email：<span style="color: #1364ef">liyaqian@oppo.com</span>
            </div>
          </div>
        </div> -->

        <div class="license">
          <div class="module_title">License：</div>
          <div class="license_content">
            <li class="txt_item">
              <p class="txt_title">1. Dataset Website</p>
              <p class="txt_content">
                OPPO Research Institute Public Data is a dataset website
                ("Site") operated by Guangdong OPPO Mobile Telecommunications
                Corp. Ltd. and/or its affiliates ("OPPO" or "we"), consisting of
                papers and related datasets. This Service Agreement on [Dataset
                Website] and other policies, rules, announcements, hyperlinks,
                notices, FAQs published on the Site (collectively, the
                "Agreement") are agreements between you and the Site with
                respect to, among other things, your access to and use of the
                Site. You click to confirm or download dataset through the Site
                or otherwise choose to accept this Agreement. If you do not
                accept this Agreement, please do not use the Site or download
                relevant dataset. In order to better provide you with service,
                please be sure to read carefully and fully understand all terms
                and conditions before you access and use the Site, especially
                the exclusion or limitation of liability, license of rights and
                use of information, legal application and dispute resolution.
                The restrictions or disclaimers will remind you to pay attention
                by bold or underlined form.
              </p>
            </li>

            <li class="txt_item">
              <p class="txt_title">2. Specification for Use</p>
              <p class="txt_content">
                Any materials and data downloaded from the Site can only be used
                for research and learning purpose. You are not allowed to sell,
                transfer or use in any commercial activities any dataset or any
                research results or outputs based on datasets obtained from the
                Site. If you use any dataset on the Site in any public place,
                for instance to publish papers or public speeches, you must
                specify the sources. Please use the Site and datasets provided
                on the Site based on the terms agreed in the Service Agreement,
                in compliance with the law and regulations, in line with the
                social public order and good morals, and in no way infringing
                upon legitimate rights and interests of any third party.
              </p>
            </li>

            <div :class="[licenseShow ? 'open' : ' close', '']">
              <li class="txt_item">
                <p class="txt_title">3. Intellectual Property</p>
                <p class="txt_content">
                  All content of the Site, including without limitation text,
                  videos, images, datasets, programs, Mark and other materials
                  and services which are protected by copyright and other
                  intellectual property rights laws, are owned by OPPO and/or
                  its authorized third parties, or used by OPPO under legal
                  authorization.
                </p>
              </li>

              <li class="txt_item">
                <p class="txt_title">4. Disclaimer</p>
                <p class="txt_content">
                  THE DATABASE PROVIDED HEREUNDER IS PROVIDED "AS IS" AND OPPO
                  MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED,
                  INCLUDING WITHOUT LIMITATION WARRANTIES OF ACCURACY,
                  COMPLETENESS, LEGALITY, NON-INFRINGEMENT, FITNESS,
                  MERCHANTABILITY FOR A PARTICULAR PURPOSE. OPPO shall have no
                  obligation to maintain, support, update, enhance or modify the
                  content of the Data. You shall be solely responsible for, and
                  shall defend OPPO from any and all claims arising from your
                  use of the Data. In no event shall OPPO be liable to either
                  party for any direct, indirect, special, incidental, punitive,
                  incidental or consequential damages arising from the use of
                  the Data Site or its documentation, even if OPPO has been
                  advised of the possibility of such damages.
                </p>
              </li>
              <li class="txt_item">
                <p class="txt_title">5. Updating of Site and Database</p>
                <p class="txt_content">
                  In consideration of the unique nature of the services provided
                  on the Site, you agree that OPPO may add, delete, modify,
                  upgrade, transfer, suspend or terminate the OPPO and the
                  related database service at any time at OPPO's sole
                  discretion.
                </p>
              </li>
              <li class="txt_item">
                <p class="txt_title">6. Governing Law and Dispute Resolution</p>
                <p class="txt_content">
                  The validity, interpretation, modification, performance and
                  dispute resolution of this Agreement shall be governed by the
                  laws of the Mainland of People's Republic of China, excluding
                  any conflict of law rules.
                </p>
              </li>
              <li class="txt_item">
                <p class="txt_content">
                  If any dispute arises in connection with the execution,
                  performance or interpretation of this Agreement between OPPO
                  and you, the parties shall use their best efforts to resolve
                  such dispute amicably through consultation. If such
                  consultation fails, OPPO and you agree to submit such dispute
                  to Shenzhen Court of International Arbitration for
                  arbitration.
                </p>
              </li>
            </div>

            <div class="show_btn" @click="_licenseTitle">
              {{ licenseShow ? "收起" : "展开" }}
              <div>
                <img
                  v-if="licenseShow"
                  class="show_icon"
                  src="@/assets/closeIcon.png"
                  alt=""
                />
                <img
                  v-else
                  class="show_icon"
                  src="@/assets/openIcon.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Bottom-Box></Bottom-Box>
  </div>
</template>

<script>
import TitBox from "@/components/title";
import HeaderName from "@/components/HeaderName";
import "@/styles/detail.less";
export default {
  name: "detail",
  components: {
    TitBox,
    HeaderName,
  },
  data() {
    return {
      activeName: "0",
      downloadHref: "https://web.xidian.edu.cn/ldli/en/dataset.html",
      BibliographyHref: "https://arxiv.org/abs/2203.16754",
      licenseShow: false,
      ceriNameList: [
        {
          name: "OPPO Research Institute",
          num: "1",
        },
        {
          name: "Xidian University",
          num: "2",
        },
      ],
      nameList: [
        {
          name: "Yuzhe Yang",
          num: "1",
        },
        {
          name: "Liwu Xu",
          num: "1",
        },
        {
          name: "Leida Li",
          num: "2",
        },
        {
          name: "Nan Qie",
          num: "1",
        },
        {
          name: "Yaqian Li",
          num: "1",
        },
        {
          name: "Peng Zhang",
          num: "1",
        },
        {
          name: "Yandong Guo",
          num: "1*",
        },
      ],
    };
  },
  methods: {
    _licenseTitle() {
      this.licenseShow = !this.licenseShow;
    },
  },
};
</script>

<style scoped lang="less">
</style>
